var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location Pin"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 446",
    cx: 16,
    cy: 13,
    r: 5,
    fill: "#082234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28652 4.02092C11.4628 -1.15541 19.8553 -1.15541 25.0315 4.02092C30.2078 9.19725 30.2078 17.5898 25.0315 22.766L15.659 32.1387L6.28652 22.766C1.11022 17.5898 1.11022 9.19725 6.28652 4.02092ZM15.659 17.1806C17.7506 17.1806 19.4461 15.4851 19.4461 13.3935C19.4461 11.302 17.7506 9.60641 15.659 9.60641C13.5675 9.60641 11.872 11.302 11.872 13.3935C11.872 15.4851 13.5675 17.1806 15.659 17.1806Z",
    fill: "#082234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.25862 14.1793L9.05862 14.1793L9.05862 14.3793C9.05862 15.7283 9.45865 17.047 10.2081 18.1687C10.9576 19.2903 12.0228 20.1646 13.2691 20.6808C14.5155 21.197 15.8869 21.3321 17.21 21.0689C18.533 20.8058 19.7484 20.1562 20.7023 19.2023C21.6562 18.2484 22.3058 17.033 22.5689 15.71C22.8321 14.3869 22.697 13.0155 22.1808 11.7691C21.6646 10.5228 20.7903 9.45758 19.6687 8.70811C18.547 7.95865 17.2283 7.55862 15.8793 7.55862L12.9415 7.55862L14.5862 5.91383L14.7277 5.77241L14.5862 5.63099L13.8138 4.85858L13.6724 4.71716L13.531 4.85858L10.2206 8.16892L10.0792 8.31034L10.2206 8.45177L13.531 11.7621L13.6724 11.9035L13.8138 11.7621L14.5862 10.9897L14.7277 10.8483L14.5862 10.7069L12.9415 9.06207L15.8793 9.06207C16.931 9.06207 17.959 9.37392 18.8334 9.95819C19.7078 10.5425 20.3893 11.3729 20.7918 12.3445C21.1942 13.3161 21.2995 14.3852 21.0944 15.4167C20.8892 16.4481 20.3828 17.3955 19.6392 18.1392C18.8955 18.8828 17.9481 19.3892 16.9166 19.5944C15.8852 19.7995 14.8161 19.6942 13.8445 19.2918C12.8729 18.8893 12.0424 18.2078 11.4582 17.3334C10.8739 16.459 10.5621 15.431 10.5621 14.3793L10.5621 14.1793L10.3621 14.1793L9.25862 14.1793Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnPin);
export default __webpack_public_path__ + "static/media/return-pin.79549ec8f5d1645aa6ddf85600aea338.svg";
export { ForwardRef as ReactComponent };